import {useState,useImperativeHandle, useRef, forwardRef, useEffect} from 'react';

interface InputTextProps {
  title: string;
  required: boolean;
  onErrorSolved?: () => void;
  onChange?: (value: string | undefined) => void;
  name?: string;
  disabled?: boolean;
  errorMessage?: string;
  labelClassName?: string;
  value?: string;
}
  
 export interface InputTextRef {
    toggle: (exeption:boolean,errortype?:number) => void;
    getValue: () => string;
    setValue: (value: string) => void;
  }

  enum enumErrorType {required = 1,unique = 2}
  

  //este componente se pretende eliminar pero por el momento lo dejamos para que no se rompa el codigo
  const InputText = forwardRef<InputTextRef, InputTextProps>(
    (props, ref) => {
    const [error, setError] = useState(false);
    const [ErrorType, setErrorType] = useState(enumErrorType.required);
    const refin = useRef<HTMLInputElement>(null);
    
    useImperativeHandle(ref, () => ({
        toggle: (exeption:boolean, errortype?:number) => {
          setError(exeption);
          if(errortype){
          setErrorType(errortype); 
          console.error(errortype);}
        },
        getValue: () => {
          return refin.current?.value || ''; // Get the input's value
        },
        setValue: (value: string) => {
          if(refin.current) {
            refin.current.value = value;
          }
        }
      })); 

      
      const handleonchange = () => {
        if (refin.current?.value.trim() !== '') {
          if (props.onErrorSolved && error) {
            props.onErrorSolved(); 
          }
          setError(false);
        }

        if (props.onChange) {
          props.onChange(refin.current?.value);
        }
      };

      useEffect(() => {
        if (props.value !== undefined && refin.current && refin.current.value !== props.value) {
          refin.current.value = props.value;
        }
      }, [props.value]);

         return (
        <div className={`flex flex-col gap-2.5 self-stretch items-start `}>
            <label className={props.labelClassName ? `${props.labelClassName} ${props.required ? 'text-[#BC3323]' : ''}` : `inputLabel ${props.required? 'text-[#BC3323]': ' text-gray-font' }  `}>
              {props.title}
            </label>
            <input name={props.name} onChange={handleonchange} ref={refin} type='text' disabled={props.disabled} value={props.value || ''} className={`flex p-3 items-start gap-[10px] self-stretch bg-[#F4F4F4] ${error ? 'outline outline-1 outline-[#BC3323]' : ' outline-none border border-[#F4F4F4] '}`}   />
            {props.errorMessage && (
                <label className="text-sm roboto_font font-medium text-[#FF6109]">
                    {props.errorMessage}
                </label>
            )}
            <label className={`flex flex-wrap items-center ${!error && 'hidden'} text-sm font-medium text-[#BC3323]`}> {`${ErrorType === 1 ? 'The ' +props.title + ' is required. ' :'This value is already registered in the DB. Please input a different/new one.' } `} </label>

        </div> 
    );
},
);

export default InputText